<template>
  <v-container style="min-height: 100vh">
    <v-form v-model="valid" ref="form">
      <v-row justify="center" class="ma-0 mb-3">
        <v-col md="9" cols="12" class="mb-0 ma-0">
          <profile-img :id="employee.id" :src="employee.avatar" />
        </v-col>

        <v-col md="9" cols="12" class="mt-1">
          <v-card width="100%" elevation="0">
            <v-row justify="center" align="center" class="px-4 pt-4">
              <v-col cols="12" sm="6">
                <v-text-field
                  prepend-icon="mdi-account-tie"
                  :label="$t('employees.input.name')"
                  v-model="employee.name"
                  :rules="[rules.required]"
                  outlined
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  prepend-icon="mdi-map-marker"
                  :label="$t('employees.input.address')"
                  v-model="employee.address"
                  :rules="[rules.required]"
                  outlined
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  prepend-icon="mdi-phone"
                  :label="$t('employees.input.phone')"
                  v-model="employee.number"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  :rules="[rules.required]"
                  outlined
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  prepend-icon="mdi-email"
                  :label="$t('auth.login.number')"
                  v-model="employee.email"
                  :rules="[rules.required, rules.emailMatch]"
                  outlined
                >
                </v-text-field>
              </v-col>

              <v-col cols="12" sm="6">
                <v-select
                  v-if="userMe.role == 1"
                  :items="items"
                  :label="$t('employees.input.position')"
                  outlined
                  prepend-icon="mdi-tag"
                  :rules="[rules.required]"
                  v-model="employee.position"
                  item-text="position"
                  return-object
                ></v-select>
                <v-select
                  v-if="userMe.role == 5"
                  :items="itemsForManager"
                  :label="$t('employees.input.position')"
                  outlined
                  prepend-icon="mdi-tag"
                  :rules="[rules.required]"
                  v-model="employee.position"
                  item-text="position"
                  return-object
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select
                  :disabled="userMe.role == 1 ? false : true"
                  :items="geoPlace"
                  filled
                  :label="$t('resorce.title')"
                  outlined
                  prepend-icon="mdi-store"
                  :rules="[rules.required]"
                  v-model="employee.src"
                  item-text="name"
                  item-value="id"
                  class="ma-1 pa-0"
                >
                  <template v-slot:item="{ item }">
                    <v-list-item-content>
                      <v-list-item-title v-text="item.name"></v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-select>
              </v-col>
              <v-col cols="12" sm="6"></v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col md="9" cols="12" class="mt-3">
          <v-card width="100%" elevation="0">
            <v-row justify="center" class="px-4 pt-4">
              <v-col cols="12" sm="12" class="ma-0 pa-0">
                <v-checkbox
                  v-model="changePass"
                  class="ma-1 pa-1"
                  :label="$t('employees.update.changePassword')"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" sm="6" v-if="changePass">
                <v-text-field
                  prepend-icon="mdi-eye"
                  :label="$t('employees.input.passowrd')"
                  v-model="password"
                  :rules="[rules.required, rules.min]"
                  outlined
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" v-if="changePass">
                <v-text-field
                  :rules="[rules.required, rules.confirmPasswordRules]"
                  outlined
                  prepend-icon="mdi-eye"
                  :label="$t('employees.input.confirmPassword')"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" v-if="!changePass">
                <v-text-field
                  prepend-icon="mdi-eye"
                  :label="$t('employees.input.passowrd')"
                  v-model="password"
                  outlined
                  disabled
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" v-if="!changePass">
                <v-text-field
                  outlined
                  disabled
                  prepend-icon="mdi-eye"
                  :label="$t('employees.input.confirmPassword')"
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col md="9" cols="12" class="mt-3">
          <v-card width="100%" elevation="0">
            <v-row justify="center" class="px-4 pt-4">
              <v-col cols="6">
                <v-btn
                  block
                  :loading="loading"
                  :disabled="loading"
                  color="primary"
                  @click="submit()"
                >
                  {{ $t("btn.save") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card></v-col
        >
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import ProfileImg from "./ProfileImg.vue";
export default {
  name: "update-page",
  components: { ProfileImg },
  data() {
    return {
      items: [
        {
          title: "Center manager",
          role: 5,
          position: "Manager",
        },
        {
          title: this.$t("position.car"),
          role: 2,
          position: "Car",
        },
        {
          title: this.$t("position.truck"),
          role: 2,
          position: "Truck",
        },
        // {
        //   title: this.$t("position.bicycle"),
        //   role: 2,
        //   position: "Bicycle",
        // },
        // {
        //   title: this.$t("position.moto"),
        //   role: 2,
        //   position: "Motocycle",
        // },
        {
          title: this.$t("position.admin"),
          role: 3,
          position: "admin",
        },
      ],
      itemsForManager: [
        {
          title: this.$t("position.admin"),
          role: 3,
          position: "admin",
        },
        {
          title: this.$t("position.car"),
          role: 2,
          position: "Car",
        },
        {
          title: this.$t("position.truck"),
          role: 2,
          position: "Truck",
        },
      ],
      position: "",
      loading: false,
      param: null,
      avatar: null,
      changePass: false,
      valid: true,
      id: 0,
      password: "",
      rules: {
        emailMatch: null,
        confirmPasswordRules: null,
        required: null,
        name: null,
        min: null,
      },
    };
  },
  created() {
    this.param = this.$router.history.current.params;
    this.rules.name = (v) => v.length >= 3 || this.$t("rules.name");
    this.rules.confirmPasswordRules = (value) =>
      value == this.password || this.$t("rules.confirmPassword");
    this.rules.min = (v) => v.length >= 6 || this.$t("rules.min_password");
    this.rules.required = (v) => !!v || this.$t("rules.require");
    this.rules.emailMatch = (v) =>
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        v
      ) || this.$t("rules.emailMatch");
  },

  computed: {
    userMe() {
      return this.$store.getters["users/userMe"];
    },
    //  ...mapState("employee"["loading"]),
    ...mapState(["geoPlace"]),
    employee() {
      return this.$store.getters["employees/employees"].filter((emp) => {
        return emp.id == this.param.id;
      })[0];
    },
  },
  methods: {
    ...mapActions("employees", ["update"]),

    submit() {
      this.$refs.form.validate();
      if (this.valid == false) return;

      let temp = { ...this.employee.position };

      this.loading = true;
      let payload = this.employee;

      payload.position = temp.position;
      payload.role = temp.role;
      payload["password"] = this.password;
      this.update(payload)
        .then((res) => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
  // created() {
  //
  // },
};
</script>
